<mat-dialog-content>
  <form [formGroup]="customerForm">
    <div class="row justify-content-start">
      <h3>
        <strong>{{ 'Register Customer' | translate }}</strong>
      </h3>
    </div>
    <div class="row">
      <span>{{ 'Customer Type' | translate }}:</span>
      <select class="form-control" formControlName="cust_type">
        <option selected value="">
          {{ 'Select customer type' | translate }}
        </option>
        @for (types of customerTypeList; track types) {
          <option [ngValue]="types">
            {{ types.type }}
          </option>
        }
      </select>
      @if (textValid('cust_type')) {
        <span class="form-text text-danger">{{
          'You must select a type' | translate
        }}</span>
      }
    </div>
    <div class="row">
      <div class="col-md-4">
        <span>{{ 'Document Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="types_docs"
          (change)="updateSelectedType()"
        >
          <option selected value="">{{ 'Select Type' | translate }}</option>
          @for (types of documenTypeList; track types) {
            <option [ngValue]="types">
              {{ types.description }}
            </option>
          }
        </select>
        @if (textValid('types_docs')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-3">
        <span> {{ 'Document Or Nit' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Document/Nit' | translate }}"
          formControlName="doc_nit"
        />
        @if (textValid('doc_nit')) {
          <span class="form-text text-danger">{{
            'The document must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-1">
        <span> {{ 'DV' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'DV' | translate }}"
          formControlName="dv"
        />
        @if (textValid('dv')) {
          <span class="form-text text-danger">{{
            'The verification digit must be only 1 numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Company Name' | translate }}:</span>
        <input
          class="form-control"
          [matAutocomplete]="autoCustomer"
          placeholder="{{ 'Name' | translate }}"
          formControlName="name"
        />
        <mat-autocomplete
          (optionSelected)="onSelectCustomer($event.option.value)"
          #autoCustomer="matAutocomplete"
          [displayWith]="displayFnCustomer"
        >
          @for (customer of customerList; track customer) {
            <mat-option [value]="customer">
              {{ customer.nombre }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (textValid('name')) {
          <span class="form-text text-danger">{{
            'The name must be wrote' | translate
          }}</span>
        }
      </div>

      <div class="col-md-4">
        <span> {{ 'Observations' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Observations' | translate }}"
          formControlName="observations"
        />
      </div>

      <div class="col-md-4">
        <span> {{ 'Company Phone' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Phone' | translate }}"
          formControlName="phone"
        />
        @if (textValid('phone')) {
          <span class="form-text text-danger">{{
            'The phone must be only numbers' | translate
          }}</span>
        }
        @if (textValid('phone')) {
          <span class="form-text text-danger">{{
            'The phone must be only 15 numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Company Email' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Email' | translate }}"
          formControlName="email"
        />
        @if (textValid('email')) {
          <span class="form-text text-danger">{{
            'The email is not a valid' | translate
          }}</span>
        }
      </div>
      @if (companyId === '9') {
        <div class="col-md-4">
          <label for="exampleFormControlFile1">RUT (PDF)</label>
          <input
            (change)="getFile($event)"
            type="file"
            class="form-control-file"
            formControlName="RUT"
          />
          @if (textValid('RUT')) {
            <span class="form-text text-danger">{{
              'You must enter the RUT in PDF' | translate
            }}</span>
          }
        </div>
      }
      <div class="col-md-4">
        <span> {{ 'Company Country' | translate }}:</span>
        <select class="form-control" formControlName="country">
          <option selected value="">{{ 'Select Country' | translate }}</option>
          @for (country of countryList; track country) {
            <option [ngValue]="country">{{ country.name }}</option>
          }
        </select>
        @if (textValid('country')) {
          <span class="form-text text-danger">{{
            'The country is not valid' | translate
          }}</span>
        }
      </div>
      @if (this.countrySelected === '170') {
        <div class="col-md-4">
          <span> {{ 'Select city' | translate }} </span>
          <select
            (change)="getCitySelect()"
            class="form-control"
            formControlName="citySelect"
          >
            <option selected value="">{{ 'Select city' | translate }}</option>
            @if (usesBilly) {
              @for (cities of billyCities.data; track cities) {
                <option [ngValue]="cities">{{ cities.attributes.name }}</option>
              }
            } @else {
              @for (city of ownCities; track city) {
                <option [ngValue]="city">{{ city.name }}</option>
              }
            }
          </select>
          @if (textValid('city')) {
            <span class="form-text text-danger">{{
              'The city is not valid' | translate
            }}</span>
          }
        </div>
      }
      @if (this.countrySelected !== '170') {
        <div class="col-md-4">
          <span> {{ 'City' | translate }}:</span>
          <input
            class="form-control"
            [matAutocomplete]="autocompleteCity"
            placeholder="{{ 'Select city' | translate }}"
            formControlName="citySelect"
          />
          <mat-autocomplete
            (optionSelected)="getCitySelect()"
            #autocompleteCity="matAutocomplete"
            [displayWith]="displayFnCity"
          >
            @for (city of filterCities$ | async; track city) {
              <mat-option [value]="city">
                {{ city }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (textValid('city')) {
            <span class="form-text text-danger">{{
              'The city is not valid' | translate
            }}</span>
          }
        </div>
      }
      <div class="col-md-4">
        <span>{{ 'Seller' | translate }}:</span>
        <select class="form-control" formControlName="seller">
          <option selected value="">{{ 'Select Seller' | translate }}</option>
          @for (seller of sellerLists; track seller) {
            <option [ngValue]="seller">
              {{ seller.seller.nombre }}
            </option>
          }
        </select>
        @if (textValid('seller')) {
          <span class="form-text text-danger">{{
            'You must select a seller' | translate
          }}</span>
        }
      </div>
    </div>

    <!-- Address Picker Section -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="address-picker-section">
          <be-one-address-picker
            [initialCoordinates]="initialCoordinates"
            [initialZoom]="13"
            [countryRestriction]="countrySelected === '170' ? 'co' : undefined"
            [searchPlaceholder]="
              ('Search company address...' | translate) ||
              'Search company address...'
            "
            [mapHeight]="'400px'"
            [mapWidth]="'100%'"
            [showAddressInfo]="true"
            [infoHeaderText]="
              ('Selected Address' | translate) || '📍 Selected Address'
            "
            [required]="true"
            [showMapControls]="true"
            [showZoomControl]="true"
            [showStreetView]="false"
            [showMapTypeControl]="false"
            [showFullscreenControl]="true"
            [allowMapClick]="true"
            [minZoom]="3"
            [maxZoom]="20"
            (addressSelected)="onAddressSelected($event)"
            (coordinatesChanged)="onCoordinatesChanged($event)"
            formControlName="addressData"
          />

          @if (
            customerForm.get('addressData')?.invalid &&
            customerForm.get('addressData')?.touched
          ) {
            <div class="alert alert-danger mt-2" role="alert">
              <v-one-icon
                name="warning"
                [type]="IconType.FILLED"
                style="margin-right: 6px; width: 16px; height: 16px"
              />
              {{ 'Please select a valid address on the map' | translate }}
            </div>
          }

          @if (
            customerForm.get('address')?.value &&
            customerForm.get('addressData')?.valid
          ) {
            <div class="alert alert-success mt-3" role="alert">
              <div class="d-flex align-items-start">
                <v-one-icon
                  name="success"
                  [type]="IconType.FILLED"
                  style="
                    margin-right: 12px;
                    margin-top: 2px;
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                  "
                />
                <div>
                  <strong>{{
                    'Address Successfully Selected' | translate
                  }}</strong
                  ><br />
                  <span class="text-muted">{{
                    customerForm.get('address')?.value
                  }}</span
                  ><br />
                  <small class="text-muted">
                    <strong>{{ 'Coordinates' | translate }}:</strong>
                    {{ customerForm.get('coordinates')?.value }}
                  </small>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <span>{{ 'Contributor Type' | translate }}:</span>
        <select class="form-control" formControlName="contributorType">
          <option selected value="">
            {{ 'Select Contributor Type' | translate }}
          </option>
          @for (contributor of contributorTypeList; track contributor) {
            <option [ngValue]="contributor">
              {{ contributor.description }}
            </option>
          }
        </select>
        @if (textValid('contributorType')) {
          <span class="form-text text-danger">{{
            'You must select a contributor type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span>{{ 'Segment' | translate }}:</span>
        <select class="form-control" formControlName="segment">
          <option selected value="">{{ 'Select Segment' | translate }}</option>
          @for (segment of customerSegmentList; track segment) {
            <option [ngValue]="segment">
              {{ segment.nombre }}
            </option>
          }
        </select>
        @if (textValid('segment')) {
          <span class="form-text text-danger">{{
            'You must select a segment' | translate
          }}</span>
        }
      </div>
    </div>
    <span class="form-text text-danger ml-2">{{
      clientErrorMessage | translate
    }}</span>
    <div class="row">
      <div
        class="d-flex flex-column flex-md-row align-items-center justify-content-start"
        id="buttons-div"
      >
        <div id="buttons">
          <button (click)="register()" mat-raised-button>
            {{ 'Register' | translate }}
          </button>
        </div>
        <div class="central-button">
          <button mat-raised-button [mat-dialog-close]="false">
            {{ 'Cancel' | translate }}
          </button>
        </div>
        @if (customerExistsName) {
          <div id="customerAlert" class="alert alert-danger">
            {{ 'ALREADY EXISTS A CUSTOMER CALLED' | translate }}:
            {{ customerExistsName }}!
          </div>
        }
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
